var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62305 0.953125C8.86445 0.711717 9.25566 0.711717 9.49707 0.953125C9.73839 1.19454 9.73845 1.58577 9.49707 1.82715L5.27637 6.04785C5.0952 6.22902 4.82977 6.27435 4.60645 6.18359C4.56924 6.1685 4.5333 6.14959 4.49902 6.12695L4.40234 6.04785L0.181641 1.82715C-0.0597674 1.58574 -0.0597674 1.19453 0.181641 0.953125C0.423049 0.711725 0.814259 0.71172 1.05566 0.953125L4.83887 4.73633L8.62305 0.953125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownIcon);
export default __webpack_public_path__ + "static/media/chevron-down-icon.1f1f1a72534452691db62527be67e26c.svg";
export { ForwardRef as ReactComponent };